import { FC } from 'react';

import { TIcon } from './TIcon/TIcon';


const IcArrowAccordion: FC<TIcon> = ({ className, onClick }) => {
  return (
   
        <svg className={className} onClick={onClick} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.9996 4.50044C12.2829 4.50044 12.5203 4.59644 12.7116 4.78844C12.9036 4.97977 12.9996 5.21711 12.9996 5.50044L12.9996 16.6754L17.8746 11.8004C18.0746 11.6004 18.3123 11.5004 18.5876 11.5004C18.8623 11.5004 19.0996 11.6004 19.2996 11.8004C19.4996 12.0004 19.5996 12.2338 19.5996 12.5004C19.5996 12.7671 19.4996 13.0004 19.2996 13.2004L12.6996 19.8004C12.5996 19.9004 12.4913 19.9714 12.3746 20.0134C12.2579 20.0548 12.1329 20.0754 11.9996 20.0754C11.8663 20.0754 11.7369 20.0548 11.6116 20.0134C11.4869 19.9714 11.3829 19.9004 11.2996 19.8004L4.69961 13.2004C4.49961 13.0004 4.39961 12.7671 4.39961 12.5004C4.39961 12.2338 4.49961 12.0004 4.69961 11.8004C4.89961 11.6004 5.13727 11.5004 5.41261 11.5004C5.68728 11.5004 5.92461 11.6004 6.12461 11.8004L10.9996 16.6754L10.9996 5.50044C10.9996 5.21711 11.0953 4.97977 11.2866 4.78844C11.4786 4.59644 11.7163 4.50044 11.9996 4.50044Z" fill="#B4B4B9"/>
        </svg>

  );
};

export default IcArrowAccordion;